<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size lg_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('FIELD.FORWARD.TITLE') }}</i>
                    </dt>
                    <dd>
                        <table class="create_table btmLine mt-20">
                            <colgroup>
                                <col width="154px" />
                                <col class="*" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.INQUIRY') }}</th>
                                    <td>
                                        <fieldset class="ui_fieldset set_2">
                                            <div>
                                                <select
                                                    class="slt_white w100p"
                                                    v-model="inquiry1Code"
                                                    @change="inquiryList(2)"
                                                    :disabled="disactive"
                                                >
                                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                    <option
                                                        v-for="item in inquiry1CodeList"
                                                        :key="pageName + item.CD"
                                                        :value="item.CD"
                                                    >
                                                        {{ item.CD_NAME }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div>
                                                <select
                                                    class="slt_white w100p"
                                                    v-model="inquiry2Code"
                                                    :disabled="disactive"
                                                >
                                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                    <option
                                                        v-for="item in inquiry2CodeList"
                                                        :key="pageName + item.CD"
                                                        :value="item.CD"
                                                    >
                                                        {{ item.CD_NAME }}
                                                    </option>
                                                </select>
                                            </div>
                                        </fieldset>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.CATEGORY') }}</th>
                                    <td>
                                        <fieldset class="ui_fieldset set_3">
                                            <div>
                                                <select
                                                    class="slt_white w100p"
                                                    v-model="category1Code"
                                                    @change="categoryList(2)"
                                                    :disabled="disactive"
                                                >
                                                    <option
                                                        v-for="item in category1CodeList"
                                                        :key="pageName + item.code"
                                                        :value="item.code"
                                                    >
                                                        {{ item.codeName }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div>
                                                <select
                                                    class="slt_white w100p"
                                                    v-model="category2Code"
                                                    @change="categoryList(3)"
                                                    :disabled="disactive"
                                                >
                                                    <option
                                                        v-for="item in category2CodeList"
                                                        :key="pageName + item.code"
                                                        :value="item.code"
                                                    >
                                                        {{ item.codeName }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div>
                                                <select
                                                    class="slt_white w100p"
                                                    v-model="category3Code"
                                                    :disabled="disactive"
                                                >
                                                    <option
                                                        v-for="item in category3CodeList"
                                                        :key="pageName + item.code"
                                                        :value="item.code"
                                                    >
                                                        {{ item.codeName }}
                                                    </option>
                                                </select>
                                            </div>
                                        </fieldset>
                                    </td>
                                </tr>
                                <tr>
                                    <th></th>
                                    <td class="text_right">
                                        <a href="javascript:" class="btn_white" @click="disactive = false">
                                            {{ $t('FIELD.CHANGE.ANSWERER.GROUP') }}
                                        </a>
                                        <a
                                            href="javascript:"
                                            class="btn_white"
                                            v-if="!('PQ6' === inquiry1Code && '4' === deptLevelCd) && 'C720' === corpCd"
                                            @click="addUser()"
                                        >
                                            {{ $t('FIELD.ADMIN.ADD') }}
                                        </a>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('TITLE.GLOBAL.ANSWERERS') }} ({{ getRhqName() }})</th>
                                    <td class="in_gird_table">
                                        <table class="scroll_table in_table sm_grid">
                                            <colgroup>
                                                <col width="20%" />
                                                <col width="*" />
                                                <col width="20%" />
                                                <col width="20%" />
                                                <col width="20%" />
                                            </colgroup>
                                            <thead class="text_center">
                                                <tr>
                                                    <th class="normal">{{ $t('FIELD.USER.ID') }}</th>
                                                    <th class="normal">{{ $t('FIELD.USER.NAME') }}</th>
                                                    <th class="normal">{{ $t('FIELD.ADMIN.PART.NAME') }}</th>
                                                    <th class="normal">{{ $t('FIELD.GLOBAL.LEVEL') }}</th>
                                                    <th class="normal">{{ $t('FIELD.GLOBAL.EMPLOYEE.ID') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody class="text_center scroll height_185">
                                                <tr v-for="answer in answerList" :key="pageName + answer.CHRG_USER_ID">
                                                    <td>{{ answer.CHRG_USER_ID }}</td>
                                                    <td>{{ answer.CHRG_USER_NM }}</td>
                                                    <td>{{ answer.DEPT_NM }}</td>
                                                    <td>{{ answer.DEPT_LEVEL_NM }}</td>
                                                    <td>{{ answer.CHRG_USER_NO }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('TITLE.POPUP.MESSAGE.DETAIL') }}<em class="txt_mandatory">*</em></th>
                                    <td><textarea class="text_textarea w100p" v-model="message"></textarea></td>
                                </tr>
                            </tbody>
                        </table>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_modal_wrap mt-0">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_blue" @click="onSave()">Send</a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import searchUserPop from '~va/qnaManager/popup/searchUserPop';

export default {
    name: 'forwardPopup',
    props: {
        question: {},
        forward: '',
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            pageName: 'forwardPopup',
            message: '',
            answerList: [],
            disactive: true,
            forDeptLevelCd: '',
            forDeptNo: '',
            inquiry1Code: '',
            inquiry2Code: '',
            category1Code: '',
            category2Code: '',
            category3Code: '',
            inquiry1CodeList: [],
            inquiry2CodeList: [],
            category1CodeList: [],
            category2CodeList: [],
            category3CodeList: [],
        };
    },
    watch: {
        inquiry1Code() {
            if (!this.disactive) this.onSearch();
        },
        inquiry2Code() {
            if (!this.disactive) this.onSearch();
        },
        category3Code() {
            if (!this.disactive) this.onSearch();
        },
    },
    mounted() {
        let forDeptLevelCd = this.deptLevelCd;
        let forDeptNo = this.corpCd;
        if ('U' === this.forward) {
            if ('4' !== forDeptLevelCd) {
                forDeptLevelCd = parseInt(forDeptLevelCd) + 1 + '';
                forDeptNo = this.loginRhq;
            }
        }
        this.forDeptLevelCd = forDeptLevelCd;
        this.forDeptNo = forDeptNo;
        this.inquiry1Code = this.question.inquiryType1;
        this.inquiry2Code = this.question.inquiryType2;
        this.category1Code = this.question.prdCategoryCd1;
        this.category2Code = this.question.prdCategoryCd2;
        this.category3Code = this.question.prdCategoryCd3;
        if (this.disactive) this.onSearch();
        this.inquiryList(1, true);
        this.categoryList(1, true);
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            loginRhq: 'getLoginRhq',
        }),
    },
    methods: {
        onSearch() {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/toAnswer/forwardSearch.skp`,
                    qs.stringify({
                        questionId: this.question.questionId,
                        forwardDiv: this.forward,
                        forDeptLevelCd: this.forDeptLevelCd,
                        forDeptNo: this.forDeptNo,
                        forRhq: this.loginRhq,
                        hSearchCategoryA: this.category1Code,
                        hSearchCategoryB: this.category2Code,
                        hSearchCategoryC: this.category3Code,
                        hSearchInquiryType1: this.inquiry1Code,
                        hSearchInquiryType2: this.inquiry2Code,
                        searchInquiryType1: this.inquiry1Code,
                        searchInquiryType2: this.inquiry2Code,
                        categoryCd3: this.category3Code,
                        message: this.message,
                    }),
                )
                .then(resp => {
                    this.answerList = resp.data.result.rowData;
                    this.forDeptLevelCd = resp.data.search.forDeptLevelCd;
                    this.forDeptNo = resp.data.search.forDeptNo;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onSave() {
            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.QNA.SELECT.USER.FORWARD.CONFIRM'),
                onOkEvt: () => {
                    let answers = [];
                    for (const answer of this.answerList) {
                        answers.push(answer.CHRG_USER_NO);
                    }

                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/toAnswer/forwardConfirm.skp`,
                            qs.stringify({
                                questionId: this.question.questionId,
                                forwardDiv: this.forward,
                                forDeptLevelCd: this.forDeptLevelCd,
                                forDeptNo: this.forDeptNo,
                                hSearchCategoryA: this.category1Code,
                                hSearchCategoryB: this.category2Code,
                                hSearchCategoryC: this.category3Code,
                                hSearchInquiryType1: this.inquiry1Code,
                                hSearchInquiryType2: this.inquiry2Code,
                                searchInquiryType1: this.inquiry1Code,
                                searchInquiryType2: this.inquiry2Code,
                                categoryCd3: this.category3Code,
                                message: this.message,
                                chrgUserNo: answers,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            this.rtnFunc();
                            this.$emit('close');
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        async inquiryList(v, recursion) {
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: 'inquiryType' + v,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.corpCd,
                        value: this.inquiry1Code,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1CodeList = resp.data.result.rowData;
                        if (recursion) {
                            this.inquiryList(2, true);
                        } else {
                            this.inquiry1Code = '';
                            this.inquiryList(2);
                        }
                    } else if (v === 2) {
                        this.inquiry2CodeList = resp.data.result.rowData;
                        if (!recursion) {
                            this.inquiry2Code = '';
                        }
                    }
                });
        },
        async categoryList(v, recursion) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1CodeList = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category1CodeList = resp;
                    if (recursion) {
                        this.categoryList(2, true);
                    } else if (!SDLUtil.isNull(resp[0])) {
                        this.category1Code = resp[0].code;
                        this.categoryList(2);
                    }
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category2CodeList = resp;
                    if (recursion) {
                        this.categoryList(3, true);
                    } else if (!SDLUtil.isNull(resp[0])) {
                        this.category2Code = resp[0].code;
                        this.categoryList(3);
                    }
                });
            } else if (v === 3) {
                codeCategoryId = 'ADM_CATEGORY_C';
                parentCode = this.category2Code;
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category3CodeList = resp;
                    if (!recursion && !SDLUtil.isNull(resp[0])) {
                        this.category3Code = resp[0].code;
                    }
                });
            }
        },
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getUserCorpCd);
            return codeResp;
        },
        getRhqName() {
            if ('4' === this.forDeptLevelCd) {
                return SDLUtil.getMsgProp('FIELD.GLOBAL.GBM');
            } else if ('3' === this.forDeptLevelCd) {
                return SDLUtil.getMsgProp('FIELD.GLOBAL.RHQ');
            } else {
                return SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY');
            }
        },
        addUser() {
            let disableDept = 'Y';
            //forward shift 이고, 사용자 부서 레벨이 4 인 경우는
            //사용자 조회시에 같은 레벨의 모든 부서의 사용자를 조회할수 있다.
            if ('S' === this.forward && '4' === this.deptLevelCd) {
                disableDept = 'N';
            }

            SDLUtil.show(
                searchUserPop,
                {
                    disableLevel: 'Y',
                    disableDept: disableDept,
                    deptLevelCd: this.forDeptLevelCd,
                    deptNo: this.forDeptNo,
                    rtnFunc: (arg1, arg2, arg3, arg4, arg5) => {
                        this.answerList.push({
                            CHRG_USER_NO: arg1,
                            CHRG_USER_ID: arg2,
                            CHRG_USER_NM: arg3,
                            DEPT_NM: arg4,
                            DEPT_LEVEL_NM: arg5,
                        });
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/popup/forwardPopup.vue